import { render } from "./AppLayout_12_8_4.vue?vue&type=template&id=43dfa67d&scoped=true"
import script from "./AppLayout_12_8_4.vue?vue&type=script&lang=js"
export * from "./AppLayout_12_8_4.vue?vue&type=script&lang=js"

import "./AppLayout_12_8_4.vue?vue&type=style&index=0&id=43dfa67d&scoped=true&lang=css"

import exportComponent from "C:\\Proyectos\\Crypto\\dex\\github\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43dfa67d"]])

export default __exports__